module.exports = __webpack_public_path__ + "static/media/icon_zhuanye.a54bb5bd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/pageBrain/icon_zhuanye.svg
// module id = 223
// module chunks = 0